import APIService from './APIService';
export default class ActiveStatusService extends APIService {
  /**
   *
   * @param {String} link
   */
  static getActiveProcess(link) {
    const url = link;
    return this.get(url);
  }
}
